import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=37d7e62f&scoped=true"
import script from "./Empty.vue?vue&type=script&lang=ts"
export * from "./Empty.vue?vue&type=script&lang=ts"
import style0 from "./Empty.vue?vue&type=style&index=0&id=37d7e62f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7e62f",
  null
  
)

export default component.exports